/**
 * Maps a list of speciality IDs to their full Speciality objects.
 *
 * Args:
 *   specialityIds: List of speciality IDs to resolve.
 *   items: Available Speciality items to search.
 *
 * Returns:
 *   Speciality[]: Resolved Speciality items in the same order as the IDs.
 */
import type { Speciality } from "../../types/index";

export const mapSpecialityIdsToItems = (
  specialityIds: number[] | undefined,
  items: Speciality[] | undefined
): Speciality[] => {
  if (!specialityIds?.length || !items?.length) {
    return [];
  }

  return specialityIds
    .map((specialityId) => items.find((item) => item.id === specialityId))
    .filter((item): item is Speciality => Boolean(item));
};
